import Common from "./mps-common";
import Dialog from "./mps-dialog";
import FormTable from "./mps-form-table";
import View from "./mps-view";

export default {

    install(Vue) {
        if (!Vue.prototype['$mps']) Vue.prototype['$mps'] = {};
        Vue.use(Common);
        Vue.use(Dialog);
        Vue.use(FormTable);
        Vue.use(View)
    },

}
